__turbopack_context__.v({
  "box": "form-module__l1APYW__box",
  "fieldset": "form-module__l1APYW__fieldset",
  "form-head": "form-module__l1APYW__form-head",
  "row": "form-module__l1APYW__row",
  "row-columns-1fr": "form-module__l1APYW__row-columns-1fr",
  "row-columns-1fr-1fr": "form-module__l1APYW__row-columns-1fr-1fr",
  "row-columns-1fr-2fr": "form-module__l1APYW__row-columns-1fr-2fr",
  "row-columns-1fr-3fr": "form-module__l1APYW__row-columns-1fr-3fr",
  "row-columns-2fr-1fr": "form-module__l1APYW__row-columns-2fr-1fr",
  "row-columns-3fr-1fr": "form-module__l1APYW__row-columns-3fr-1fr",
});
